import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AgenticMode = 'editor' | 'agents';

const STORAGE_KEY = 'agentic_assistant_mode';

@Injectable({
  providedIn: 'root'
})
export class AgenticModeService {
  private readonly modeSubject = new BehaviorSubject<AgenticMode>(this.getInitialMode());
  readonly mode$ = this.modeSubject.asObservable();

  get currentMode(): AgenticMode {
    return this.modeSubject.getValue();
  }

  setMode(mode: AgenticMode): void {
    if (!mode || mode === this.currentMode) {
      return;
    }

    this.modeSubject.next(mode);
    try {
      sessionStorage.setItem(STORAGE_KEY, mode);
    } catch (error) {
      console.error('Failed to persist agentic mode', error);
    }
  }

  private getInitialMode(): AgenticMode {
    try {
      const stored = sessionStorage.getItem(STORAGE_KEY) as AgenticMode | null;
      if (stored === 'agents' || stored === 'editor') {
        return stored;
      }
    } catch (error) {
      console.warn('Unable to read agentic mode from sessionStorage', error);
    }
    return 'editor';
  }
}

